module.exports = __webpack_public_path__ + "img/help_dataset_state_small.780b1a4a.png";